module.exports = {
    APPLICATION_ID: 't9YeAnwEHaQPnffKpsXZUxcpEuaAns5d7u3LTeO9',
    JAVASCRIPT_KEY: 'MtZ7MYaUKU1qk8yZv4mxmEqmy0czYP6muR7dMqPv',
    SERVER_URL: 'https://parseapi.back4app.com/'
}
